import { createFileRoute } from "@tanstack/react-router";
import { TransportPage, transportHead } from "@/pages/TransportPage";

export const Route = createFileRoute("/de/branchen/transport-logistik")({
  head: () => transportHead("de"),
  component: () => <TransportPage locale="de" />,
});
